const getters = {
    users: (state) => {
        return state.users
    },
    users_summary: (state) => {
        return state.users_summary
    },
    theme: (state) => {
        return state.theme
    },
    isThemeDark(state, getters) {
        return getters.themeMode === 'dark' || getters.themeMode === 'semi-dark'
    }
}

export default getters
